<template>
  <div class="py-5 training-section">
    <div class="container">
      <h3 class="fw-bold text-center">Training Tracks</h3>
      <p class="text-center sub-heading mx-auto">
        Our training programs have been expertly crafted to equip you with the
        essential knowledge, tools, and hands-on experience required to excel
      </p>

      <div class="my-5">
        <div class="row">
          <div class="col-md-6">
            <ul class="track-list">
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Android development
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Frontend Website Development
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Backend Website Development
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Computer Aided Design (CAD)
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Embedded Systems
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="track-list">
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Digital Marketing
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Programming Foundation
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                Data Science
              </li>
              <li class="d-flex gap-2">
                <div class="text-primary"><i class="bi bi-apple"></i></div>
                User Interface & User Experience (UI/UX)
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <router-link to="/training" class="btn btn-outline-primary px-5"
          >Get Detailed Info</router-link
        >
      </div>
    </div>
  </div>
</template>

<style scoped>
.training-section ul li {
  font-size: 22px;
  margin-bottom: 20px;
}

.training-section .sub-heading {
  width: 50%;
  font-size: 20px;
}

@media (max-width: 426px) {
  .training-section ul li {
    font-size: 18px;
  }

  .training-section .sub-heading {
    width: 100%;
  }
}
</style>